import { useCallback, useState } from 'react';

export const useCopyButton = () => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = useCallback(() => {
    setCopied(true);
  }, []);

  const resetCopied = useCallback(() => {
    setCopied(false);
  }, []);

  return {
    copied,
    copyToClipboard,
    resetCopied,
  };
};
